interface ConvexErrorLike {
  data?: unknown;
}

interface PanelistStaleData {
  code: "PANELIST_STALE";
  message: string;
}

export function panelistStaleMessage(error: unknown): string | null {
  if (!error || typeof error !== "object") return null;
  const data = (error as ConvexErrorLike).data;
  if (!isPanelistStaleData(data)) return null;
  return data.message;
}

function isPanelistStaleData(data: unknown): data is PanelistStaleData {
  if (!data || typeof data !== "object") return false;
  const candidate = data as Partial<PanelistStaleData>;
  return candidate.code === "PANELIST_STALE" && typeof candidate.message === "string";
}
